import styled from "@emotion/styled";
import { Ui } from "@silvertours/front-shared";
var StyledLogo = /*#__PURE__*/ styled(Ui.Logo, {
    target: "ezx5tbt0"
})("fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";");
export { StyledLogo };
